/**
 * POST User Action
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';

import {
  ACTION_SAVE_PROFILE_SUCCESS,
  ACTION_SAVE_PROFILE_FAILURE,
  ACTION_SAVE_PROFILE_RESET_ERRORS,
  API_CALL,
} from '../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function save(name: string, email: string) {
  return (dispatch: Dispatch, getState: Function) => {
    var dataToSend: any = {
      name: name,
      email: email,
    };

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'profile',
        method: 'put',
        data: JSON.stringify(dataToSend),
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { putProfileSuccess: true },
              'success',
            );
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_SAVE_PROFILE_SUCCESS,
    payload: responeJSON,
  };
}

function requestFailed(responeJSON: object) {
  return {
    type: ACTION_SAVE_PROFILE_FAILURE,
    payload: responeJSON,
  };
}

export function resetErrors() {
  return (dispatch: Dispatch, getState: Function) => {
    // Dispatch the api call request.
    dispatch({
      type: ACTION_SAVE_PROFILE_RESET_ERRORS,
      payload: null,
    });
  };
}
